// Auto-generated normalizer for table: CAR_BOOKING.ExtrasAcumuladoMes
export function extrasAcumuladoMesNormalize(row) {
  return {
    id: row.id ?? row.Id ?? row['id'] ?? 0,
    idChofer: row.idChofer ?? row.IdChofer ?? row['idChofer'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    mes: row.mes ?? row.Mes ?? row['mes'] ?? 0,
    anio: row.anio ?? row.Anio ?? row['anio'] ?? 0,
    horasExtras: row.horasExtras ?? row.HorasExtras ?? row['horasExtras'] ?? 0,
    acumuladas: row.acumuladas ?? row.Acumuladas ?? row['acumuladas'] ?? '',
    fechaCorte: row.fechaCorte ?? row.FechaCorte ?? row['fechaCorte'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}